import { Component, OnInit } from '@angular/core';
import { ProfileAdvancedSearchParams } from '../../profile-advanced-search-params.model';
import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { MemberService } from 'src/app/member/shared/member.service';
import { MemberActivityBulkCreateDto } from 'src/app/profiles/shared/dto/member-activity-bulk-create.dto';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'wl-member-activity-search-action',
  templateUrl: './member-activity-search-action.component.html',
  styleUrls: ['./member-activity-search-action.component.less'],
    standalone: false
})
export class MemberActivitySearchActionComponent implements OnInit {
  public memberActivityTypes = [];
  public showCreateMemberActivityDialog = false;
  public selectedActivityId = 0;
  public activityDate: Date;
  public valid = false;

  constructor(private _profileService: ProfileService, private _memberService: MemberService) {}

  ngOnInit(): void {
    this._memberService.getMemberActivityTypes().then((data) => {
      this.memberActivityTypes = data.map<SelectItem>((x) => {
        return { label: x.Descr, value: x.ActivityTypeID };
      });
    });
  }

  public cancelCreateActivity() {
    this.showCreateMemberActivityDialog = false;
  }

  public massCreateMemberActivity(searchParams: ProfileAdvancedSearchParams) {
    this._profileService.massCreateMemberActivity(searchParams, {
      MemberActivityDate: this.activityDate,
      MemberActivityTypeId: this.selectedActivityId,
    } as MemberActivityBulkCreateDto);
  }

  public createMemberActivities(profileIds: Array<number>) {
    this._profileService.bulkCreateMemberActivity({
      MemberActivityDate: this.activityDate,
      MemberActivityTypeId: this.selectedActivityId,
      ProfileIds: profileIds,
    } as MemberActivityBulkCreateDto);
  }

  public onFieldChange() {
    this.valid = this.selectedActivityId > 0 && this.activityDate != null;
  }
}
